export const TEACH_DEMO_ROUTE_SLUGS = ["dutch", "english", "spanish", "french", "german"] as const;

export type TeachDemoRouteSlug = (typeof TEACH_DEMO_ROUTE_SLUGS)[number];

export type TeachDemoRoute = {
  slug: TeachDemoRouteSlug;
  targetLanguageCode: string;
  targetLanguageName: string;
  instructionLanguageCode: string;
  instructionLanguageName: string;
  courseLabel: string;
  courseDescription: string;
};

export const TEACH_DEMO_ROUTES: readonly TeachDemoRoute[] = [
  {
    slug: "dutch",
    targetLanguageCode: "nl-NL",
    targetLanguageName: "Dutch",
    instructionLanguageCode: "en-US",
    instructionLanguageName: "English",
    courseLabel: "Dutch",
    courseDescription: "Dutch course",
  },
  {
    slug: "english",
    targetLanguageCode: "en-GB",
    targetLanguageName: "English",
    instructionLanguageCode: "es-ES",
    instructionLanguageName: "Spanish",
    courseLabel: "English to Spanish speakers",
    courseDescription: "English course for Spanish speakers",
  },
  {
    slug: "spanish",
    targetLanguageCode: "es-ES",
    targetLanguageName: "Spanish",
    instructionLanguageCode: "en-US",
    instructionLanguageName: "English",
    courseLabel: "Spanish",
    courseDescription: "Spanish course",
  },
  {
    slug: "french",
    targetLanguageCode: "fr-FR",
    targetLanguageName: "French",
    instructionLanguageCode: "en-US",
    instructionLanguageName: "English",
    courseLabel: "French",
    courseDescription: "French course",
  },
  {
    slug: "german",
    targetLanguageCode: "de-DE",
    targetLanguageName: "German",
    instructionLanguageCode: "en-US",
    instructionLanguageName: "English",
    courseLabel: "German",
    courseDescription: "German course",
  },
] as const;

export function getTeachDemoRoute(slug: string): TeachDemoRoute | undefined {
  return TEACH_DEMO_ROUTES.find((route) => route.slug === slug);
}
